import { createAsyncThunk } from '@reduxjs/toolkit';
import { apiFetch } from '../../../utilities/appFetch';
import permissionGroupRoutes from '../../../components/permissionGroup/permissionGroupRoutes';

const readAll = createAsyncThunk(
  'thunk/permissionGroup/readAll',
  async (arg, thunkAPI) => {
    const response = await apiFetch(permissionGroupRoutes.api.readAll, {
      body: arg?.data,
    });
    if (!response?.success) {
      return thunkAPI.rejectWithValue(response);
    }
    return response.result;
  },
);

export default readAll;
